import React from 'react';
import { Modal } from 'antd';

import ViewPanel from 'vcomponents/Form/ViewPanel';

import { useGetTermLatest, useSaveQuickOrder } from '../../hooks';
import { IQuickBookingParams, IQuickOrderAddress, QUICK_LOADING_METHOD } from '../../types';
import { toSendAppointmentDate } from '../utils';

export const CommonAddressForm = ({ id, value, isLarge }: { id: string; value?: any; isLarge?: boolean }) => (
  <div id={id}>
    <ul style={{ margin: 0, paddingLeft: '24px' }}>
      <li style={{ listStyleType: 'disc' }}>주소 : {value?.roadAddress}</li>
      <li style={{ listStyleType: 'disc' }}>상세 주소 : {value?.addressDetail}</li>
      <li style={{ listStyleType: 'disc' }}>이름 : {value?.name}</li>
      <li style={{ listStyleType: 'disc' }}>연락처 : {value?.cellphone}</li>
      {isLarge ? (
        <>
          <li style={{ listStyleType: 'disc' }}>배송 운반 지원 : {QUICK_LOADING_METHOD[value?.loadingMethod]}</li>
          <li style={{ listStyleType: 'disc' }}>
            {id === 'pickup' ? '상차' : '하차'} 시 기사님 확인사항 : {value?.description ?? '-'}
          </li>
        </>
      ) : null}
    </ul>
  </div>
);

interface QuickOrderPriceModalProps {
  open: boolean;
  close: () => void;
  quickData: IQuickBookingParams;
  quickOrderPrice: number;
  history: any;
}

const QuickOrderPriceModal = ({ open, close, quickData, quickOrderPrice, history }: QuickOrderPriceModalProps) => {
  const { mutateAsync: saveQuickOrder, isLoading } = useSaveQuickOrder();
  const { data } = useGetTermLatest({ types: 'QUICK_NOTICE' });

  const formatAddress = (address?: IQuickOrderAddress): IQuickOrderAddress => ({
    ...address,
    addressBookName: address?.addressBookName || address?.name,
    isSaveAddress: address?.isSaveAddress ?? false
  });

  const handleSubmit = async () => {
    const quickIdx = await saveQuickOrder({
      ...quickData,
      pickup: formatAddress(quickData?.pickup),
      dropoff: formatAddress(quickData?.dropoff),
      appointmentDate: toSendAppointmentDate(quickData?.appointmentDate)
    });
    history.push(`/service/quick/reservation/${quickIdx}`, { quickIdx });
    close();
  };

  return (
    <Modal
      title="예상 운임 확인"
      visible={open}
      onCancel={close}
      width={1000}
      okText="예약 확정하기"
      onOk={handleSubmit}
      okButtonProps={{ loading: isLoading }}
    >
      <ViewPanel title="예상 운임" theme="none">
        <div style={{ padding: '16px', fontSize: '20px', textAlign: 'center' }}>
          <span>현재 설정된 조건으로 계산된 예상 운임은 </span>
          <span style={{ color: 'blue', fontWeight: 'bolder' }}>{(quickOrderPrice ?? 0).toLocaleString()}원</span>
          <span> 입니다.</span>
        </div>
        <div>
          {data?.termList?.length ? (
            <div>
              <div style={{ paddingTop: '24px', fontWeight: 700 }}>{data?.termList?.[0].title}</div>
              <ul style={{ paddingLeft: '12px' }}>
                {data?.termList[0].content
                  .replaceAll('- ', '')
                  .split('\n')
                  .filter(Boolean)
                  .map((term) => (
                    <li key={term} style={{ listStyleType: 'disc' }}>
                      {term}
                    </li>
                  ))}
              </ul>
            </div>
          ) : null}
        </div>
      </ViewPanel>
    </Modal>
  );
};

export default QuickOrderPriceModal;
